import React from "react";
import { Button, Divider, Input } from '@nextui-org/react';
import dayjs from '../../lib/day';

const Filter = ({
  ratingCategoryList = [],
  dateRange = [],
  topSelection = [],
  topCategory = [],
  focusAreaId,
  dateRangeId,
  topSelectionId,
  topCategoryId,
  startDate,
  endDate,
  stopName,
  setValueToState,
  handleSubmit
}) => {
  const handleDateRangeChange = (e) => {
    const value = e.target.value;
    const today = dayjs();
    
    const dateConfigs = {
      "1": { days: 1 },
      "7": { days: 7 },
      "30": { days: 30 },
      "365": { days: 365 }
    };

    if (dateConfigs[value]) {
      setValueToState("startDate", today.format("YYYY-MM-DD"));
      setValueToState("endDate", today.subtract(dateConfigs[value].days, "days").format("YYYY-MM-DD"));
    } else {
      setValueToState("startDate", "");
      setValueToState("endDate", "");
    }
    setValueToState("dateRangeId", value);
  };

  const handleReset = () => {
    setValueToState("focusAreaId", "");
    setValueToState("dateRangeId", "0");
    setValueToState("startDate", "");
    setValueToState("endDate", "");
    setValueToState("stopName", "");
    setValueToState("topSelectionId", "10");
    setValueToState("topCategoryId", "DESC");
    
    handleSubmit();
  };

  return (
    <div className="card bg-base-100 shadow-xl p-6 w-[400px]">
      <div className="space-y-4">
        {/* Focus Area Selection */}
        <div className="form-control w-full">
          <label className="label">
            <span className="label-text font-semibold">Focus Area</span>
          </label>
          <select
            className="select select-bordered w-full"
            value={focusAreaId}
            onChange={(e) => setValueToState("focusAreaId", e.target.value)}
          >
            {ratingCategoryList.map((item) => (
              <option key={item.id} value={item.id}>
                {item.cat_desc}
              </option>
            ))}
          </select>
        </div>

        {/* Date Range Selection */}
        <div className="form-control w-full">
          <label className="label">
            <span className="label-text font-semibold">Date Range</span>
          </label>
          <select
            className="select select-bordered w-full"
            value={dateRangeId}
            onChange={handleDateRangeChange}
          >
            {dateRange.map((item) => (
              <option key={item.value} value={item.value}>
                {item.lable}
              </option>
            ))}
          </select>
        </div>

        {/* Date Inputs */}
        <div className="form-control w-full">
          <label className="label">
            <span className="label-text font-semibold">Custom Date Range</span>
          </label>
          <div className="flex items-center gap-2">
            <input
              type='date'
              placeholder="Start Date"
              onChange={e => setValueToState("endDate", e.target.value)}
              className="input input-bordered w-full"
              value={endDate}
            />
            <input
              type='date'
              placeholder="End Date"
              onChange={e => setValueToState("startDate", e.target.value)}
              className="input input-bordered w-full"
              value={startDate}
            />
          </div>
        </div>

        {/* Stop Name Input */}
        <div className="form-control w-full">
          <label className="label">
            <span className="label-text font-semibold">Stop Name</span>
          </label>
          <input
            type="text"
            placeholder="Enter stop name"
            className="input input-bordered w-full"
            onChange={e => setValueToState("stopName", e.target.value)}
            value={stopName}
          />
        </div>

        {/* Top Selection and Category */}
        <div className="grid grid-cols-2 gap-4">
          <div className="form-control w-full">
            <label className="label">
              <span className="label-text font-semibold">Top Selection</span>
            </label>
            <select
              className="select select-bordered w-full"
              value={topSelectionId}
              onChange={(e) => setValueToState("topSelectionId", e.target.value)}
            >
              {topSelection.map((item) => (
                <option key={item.value} value={item.value}>
                  {item.lable}
                </option>
              ))}
            </select>
          </div>

          <div className="form-control w-full">
            <label className="label">
              <span className="label-text font-semibold">Top Category</span>
            </label>
            <select
              className="select select-bordered w-full"
              value={topCategoryId}
              onChange={(e) => setValueToState("topCategoryId", e.target.value)}
            >
              {topCategory.map((item) => (
                <option key={item.value} value={item.value}>
                  {item.lable}
                </option>
              ))}
            </select>
          </div>
        </div>

        <Divider className="my-4" />
        
        <div className="flex justify-between">
          <Button
            auto
            size='sm'
            className="btn btn-ghost"
            onClick={handleReset}
          >
            Reset
          </Button>
          <Button
            auto
            size='sm'
            className="btn btn-primary"
            onClick={handleSubmit}
          >
            Apply Filters
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Filter;